export default {
  install(Vue) {
    Vue.directive('arabic-only', {
      inserted(el) {
        const input = findInput(el);
        if (!input) return;

        // RTL solo en el input
        input.setAttribute('dir', 'rtl');
        input.setAttribute('lang', 'ar');

        const arabicRegex = /[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s]/g;

        const sanitize = () => {
          const clean = input.value.replace(arabicRegex, '');
          if (clean !== input.value) {
            input.value = clean;
            input.dispatchEvent(new Event('input'));
          }
        };

        // 🔑 EL CORAZÓN DE LA SOLUCIÓN
        input.addEventListener('input', sanitize);
        input.addEventListener('compositionend', sanitize);

        // fallback extra por si el browser se pone creativo
        input.addEventListener('keyup', sanitize);
        input.addEventListener('change', sanitize);

        input.__arabicOnly__ = sanitize;
      },

      unbind(el) {
        const input = findInput(el);
        if (!input || !input.__arabicOnly__) return;

        const s = input.__arabicOnly__;
        input.removeEventListener('input', s);
        input.removeEventListener('compositionend', s);
        input.removeEventListener('keyup', s);
        input.removeEventListener('change', s);

        delete input.__arabicOnly__;
      }
    });

    function findInput(el) {
      if (!(el instanceof HTMLElement)) return null;
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') return el;
      return el.querySelector?.('input, textarea') || null;
    }
  }
};